function pad(n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

function sleep(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
 }

function copy(aObject) {
  if (!aObject) {
  return aObject;
  }
  
  let v;
  let bObject = Array.isArray(aObject) ? [] : {};
  for (const k in aObject) {
  v = aObject[k];
  bObject[k] = (typeof v === "object") ? copy(v) : v;
  }
  
  return bObject;
}

function setColor3(color,trans,theme){
  console.log(theme)
  if (theme!=="dark"){
    return setColor2(color,trans)
  } else {
    var red=color.substr(0,3)
    var green=color.substr(3,3)
    var blue=color.substr(6,3)
    red=(Math.max(Number(red)-180,0)).toString()
    green=(Math.max(Number(green)-180,0)).toString()
    blue=(Math.max(Number(blue)-180,0)).toString()
    return setColor(red,green,blue,trans)
  }
}

function setColor2(color,trans){
  var red=color.substr(0,3)
  var green=color.substr(3,3)
  var blue=color.substr(6,3)
  return setColor(red,green,blue,trans)
}

function setColor(red,green,blue,trans){
  var transFinal=trans?trans:"1"
  return `rgba(${red},${green},${blue},${transFinal})`
}

function setGradient2(color){
  var red=color.substr(0,3)
  var green=color.substr(3,3)
  var blue=color.substr(6,3)
  return setGradient(red,green,blue)
}

function setGradient(red,green,blue){
  return `
    repeating-linear-gradient(-53deg,
      ${setColor(red, green, blue, "0")},
      ${setColor(red, green, blue, "0")} 5px,
      ${setColor(red, green, blue, "0.7")} 5px,
      ${setColor(red, green, blue, "0.7")} 10px
    )
  `
}

function ObjectContentIsEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  
  if (keys1.length !== keys2.length) {
    return false;
  }
  
  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if ((areObjects && !ObjectContentIsEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
      return false;
    }
  }
  return true;
}
  
function isObject(object) {
  return object != null && typeof object === 'object';
}

function roundTo(num,prec,type){
  if (type==="up"||type==="ceil"||type==="ceiling"){
    return Number(Math.ceil(num*(10**prec))/(10**prec))
  } else if (type==="down"||type==="floor"){
    return Number(Math.floor(num*(10**prec))/(10**prec))
  } else {
    return Number(Math.round(num+'e'+prec)+'e-'+prec)
  }
}

function isImage(file) {
  return ['image/gif','image/jpeg','image/png','image/tiff','image/svg+xml','image/webp'].includes(file.type);
}


export {pad, sleep, copy, setColor, setColor2, setColor3, setGradient, setGradient2, ObjectContentIsEqual,roundTo,isImage};